export default __webpack_public_path__ + "static/media/newsEve3.85aeda2f.jpg";